import * as React from "react";

const SignIn: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="-1 -1 28 28"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="26"
            height="26"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M13 0c7.18 0 13 5.82 13 13s-5.82 13-13 13C7.153 26 2.21 22.142.575 16.838h1.232C3.406 21.483 7.817 24.83 13 24.83c6.523 0 11.83-5.307 11.83-11.83S19.523 1.17 13 1.17c-5.184 0-9.594 3.347-11.193 7.992H.575C2.21 3.858 7.153 0 13 0zm.364 6.867l5.899 5.902c.065.065.097.15.094.231a.311.311 0 01-.094.23l-5.899 5.903a.328.328 0 01-.462 0l-.367-.368a.328.328 0 010-.461l4.72-4.719H.324A.326.326 0 010 13.26v-.52c0-.179.146-.325.325-.325h16.93l-4.72-4.719a.328.328 0 010-.462l.367-.367a.328.328 0 01.462 0z"
            />
        </svg>
    );
};

export default React.memo(SignIn);
